module.exports = __webpack_public_path__ + "6b201b3d7a9ca5aeebedc865861ff63a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/archer-daniels-midland-co.png
// module id = 1750
// module chunks = 0